import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { MenuItem } from './menu-item.component';
import { useVersionSwitcher } from '../../hooks/useVersionSwitcher';
import { useLocalizedRoutes } from '../../hooks/useLocalizedRoutes';
import '../../scss/sidebar.style.scss';
import invozioLogo from '../../../assets/6fbfd90461888be678ed8de41aebe28e725968d7.svg';
import i18n from '../../lib/i18n';
import { getItem } from '../../helper/localstorage.helper';

const defaultMenuSections = (t: (key: string) => string, routes: any) => [
  {
    id: 'main',
    title: t('SIDEBAR_MAIN'),
    items: [
      {
        id: 'dashboard',
        label: t('SIDEBAR_DASHBOARD'),
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={18}
            viewBox="0 0 20 18"
            fill="none"
          >
            <path
              d="M0.833008 7.77133L8.74905 1.90859C9.48465 1.3638 10.5147 1.3638 11.2503 1.90859L19.1663 7.77133M3.88856 5.50834L3.88856 14.5603C3.88856 15.6316 4.80058 16.5 5.9256 16.5H14.0737C15.1988 16.5 16.1108 15.6316 16.1108 14.5603V5.50834"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
            />
          </svg>
        ),
        href: '/v2/dashboard',
        isActive: true
      },      
      {
        id: 'invoices',
        label: t('SIDEBAR_INVOICES'),
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M5.99968 18.3346V17.3346H5.99968L5.99968 18.3346ZM13.9997 18.3346V19.3346V18.3346ZM16.6663 15.668H15.6663H16.6663ZM16.6663 4.33464H17.6663H16.6663ZM16.4847 2.57798L17.3757 2.12399V2.12399L16.4847 2.57798ZM13.9997 1.66797L13.9997 0.667969L13.9997 1.66797ZM15.7563 1.84962L16.2103 0.958619L16.2103 0.958618L15.7563 1.84962ZM15.7563 18.153L16.2103 19.044L15.7563 18.153ZM16.4847 17.4246L15.5937 16.9706L16.4847 17.4246ZM4.24302 18.153L4.69702 17.262L4.24302 18.153ZM3.33301 15.668H2.33301H3.33301ZM3.51466 17.4246L4.40567 16.9706L3.51466 17.4246ZM4.33301 6.66797C4.33301 6.11568 3.88529 5.66797 3.33301 5.66797C2.78072 5.66797 2.33301 6.11568 2.33301 6.66797L3.33301 6.66797H4.33301ZM8.33301 0.667969C7.78072 0.667969 7.33301 1.11568 7.33301 1.66797C7.33301 2.22025 7.78072 2.66797 8.33301 2.66797V1.66797L8.33301 0.667969ZM3.47527 6.52571L2.76816 5.8186L3.47527 6.52571ZM8.19075 1.81023L8.89786 2.51734L8.19075 1.81023ZM3.53419 6.66797L3.53419 7.66797L3.53419 6.66797ZM7.49968 6.66797V5.66797V6.66797ZM8.33301 5.83464H7.33301H8.33301ZM8.33301 1.86915H9.33301V1.86915L8.33301 1.86915ZM6.66634 9.0013C6.11406 9.0013 5.66634 9.44902 5.66634 10.0013C5.66634 10.5536 6.11406 11.0013 6.66634 11.0013V10.0013V9.0013ZM13.333 11.0013C13.8853 11.0013 14.333 10.5536 14.333 10.0013C14.333 9.44902 13.8853 9.0013 13.333 9.0013V10.0013V11.0013ZM11.6663 5.66797C11.1141 5.66797 10.6663 6.11568 10.6663 6.66797C10.6663 7.22025 11.1141 7.66797 11.6663 7.66797L11.6663 6.66797V5.66797ZM13.333 7.66797C13.8853 7.66797 14.333 7.22025 14.333 6.66797C14.333 6.11568 13.8853 5.66797 13.333 5.66797V6.66797L13.333 7.66797ZM6.66634 12.3346C6.11406 12.3346 5.66634 12.7824 5.66634 13.3346C5.66634 13.8869 6.11406 14.3346 6.66634 14.3346V13.3346V12.3346ZM13.333 14.3346C13.8853 14.3346 14.333 13.8869 14.333 13.3346C14.333 12.7824 13.8853 12.3346 13.333 12.3346V13.3346V14.3346ZM5.99968 18.3346V19.3346H13.9997V18.3346L13.9997 17.3346H5.99968V18.3346ZM16.6663 15.668H17.6663V4.33464H16.6663H15.6663L15.6663 15.668H16.6663ZM16.6663 4.33464H17.6663C17.6663 3.88443 17.6671 3.48663 17.6403 3.15854C17.6126 2.81878 17.5503 2.46672 17.3757 2.12399L16.4847 2.57798L15.5937 3.03197C15.6007 3.04577 15.6293 3.10532 15.647 3.3214C15.6656 3.54916 15.6663 3.85142 15.6663 4.33464L16.6663 4.33464ZM13.9997 1.66797V2.66797C14.4829 2.66797 14.7852 2.66875 15.0129 2.68735C15.229 2.70501 15.2885 2.7336 15.3023 2.74063L15.7563 1.84962L16.2103 0.958618C15.8676 0.783989 15.5155 0.721756 15.1758 0.693997C14.8477 0.667191 14.4499 0.667969 13.9997 0.667969L13.9997 1.66797ZM16.4847 2.57798L17.3757 2.12399C17.12 1.62222 16.7121 1.21428 16.2103 0.958619L15.7563 1.84962L15.3023 2.74063C15.4278 2.80455 15.5298 2.90654 15.5937 3.03197L16.4847 2.57798ZM13.9997 18.3346V19.3346C14.4499 19.3346 14.8477 19.3354 15.1758 19.3086C15.5155 19.2808 15.8676 19.2186 16.2103 19.044L15.7563 18.153L15.3023 17.262C15.2885 17.269 15.229 17.2976 15.0129 17.3152C14.7852 17.3339 14.4829 17.3346 13.9997 17.3346L13.9997 18.3346ZM16.6663 15.668H15.6663C15.6663 16.1512 15.6656 16.4534 15.647 16.6812C15.6293 16.8973 15.6007 16.9568 15.5937 16.9706L16.4847 17.4246L17.3757 17.8786C17.5503 17.5359 17.6126 17.1838 17.6403 16.8441C17.6671 16.516 17.6663 16.1182 17.6663 15.668H16.6663ZM15.7563 18.153L16.2103 19.044C16.7121 18.7883 17.12 18.3804 17.3757 17.8786L16.4847 17.4246L15.5937 16.9706C15.5298 17.0961 15.4278 17.1981 15.3023 17.262L15.7563 18.153ZM5.99968 18.3346L5.99968 17.3346C5.51646 17.3346 5.2142 17.3339 4.98644 17.3152C4.77036 17.2976 4.71081 17.269 4.69702 17.262L4.24302 18.153L3.78903 19.044C4.13176 19.2186 4.48382 19.2808 4.82358 19.3086C5.15167 19.3354 5.54947 19.3346 5.99968 19.3346V18.3346ZM3.33301 15.668H2.33301C2.33301 16.1182 2.33223 16.516 2.35904 16.8441C2.3868 17.1838 2.44903 17.5359 2.62366 17.8786L3.51466 17.4246L4.40567 16.9706C4.39864 16.9568 4.37005 16.8973 4.35239 16.6812C4.33379 16.4534 4.33301 16.1512 4.33301 15.668H3.33301ZM4.24302 18.153L4.69702 17.262C4.57157 17.1981 4.46959 17.0961 4.40567 16.9706L3.51466 17.4246L2.62366 17.8786C2.87932 18.3804 3.28727 18.7883 3.78903 19.044L4.24302 18.153ZM3.33301 6.66797L2.33301 6.66797L2.33301 15.668H3.33301H4.33301L4.33301 6.66797H3.33301ZM13.9997 1.66797L13.9997 0.667969L8.33301 0.667969L8.33301 1.66797V2.66797L13.9997 2.66797V1.66797ZM3.47527 6.52571L4.18237 7.23282L8.89786 2.51734L8.19075 1.81023L7.48364 1.10312L2.76816 5.8186L3.47527 6.52571ZM3.53419 6.66797L3.53419 7.66797L7.49968 7.66797V6.66797V5.66797L3.53419 5.66797L3.53419 6.66797ZM8.33301 5.83464H9.33301V1.86915H8.33301L7.33301 1.86915L7.33301 5.83464H8.33301ZM7.49968 6.66797V7.66797C8.5122 7.66797 9.33301 6.84716 9.33301 5.83464L8.33301 5.83464H7.33301C7.33301 5.74259 7.40763 5.66797 7.49968 5.66797V6.66797ZM8.19075 1.81023L8.89786 2.51734C8.32039 3.0948 7.33301 2.68582 7.33301 1.86915L8.33301 1.86915L9.33301 1.86915C9.33301 0.904004 8.1661 0.420663 7.48364 1.10312L8.19075 1.81023ZM3.47527 6.52571L2.76816 5.8186C2.0857 6.50107 2.56905 7.66797 3.53419 7.66797L3.53419 6.66797L3.53419 5.66797C4.35086 5.66797 4.75984 6.65535 4.18237 7.23282L3.47527 6.52571ZM6.66634 10.0013V11.0013L13.333 11.0013V10.0013V9.0013L6.66634 9.0013V10.0013ZM11.6663 6.66797L11.6663 7.66797H13.333L13.333 6.66797V5.66797H11.6663V6.66797ZM6.66634 13.3346V14.3346L13.333 14.3346V13.3346V12.3346L6.66634 12.3346V13.3346Z"
              fill="currentColor"
            />
          </svg>

        ),
        submenu: [
          { id: 'create-invoices', label: t('CREATE_INVOICES'), href: 'create-invoices' },
          { id: 'all-invoices', label: t('MANAGE_INVOICES'), href: 'all-invoices' },
          { id: 'draft-invoices', label: t('SIDEBAR_DRAFT_INVOICES'), href: 'draft-invoice' },
          // { id: 'paid-invoices', label: t('SIDEBAR_PAID_INVOICES'), href: 'paid-invoice' }
        ]
      },
      {
        id: 'clients-contracts',
        label: t('SIDEBAR_CLIENTS_CONTRACTS'),
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={21}
            height={21}
            viewBox="0 0 21 21"
            fill="none"
          >
            <path
              d="M7.93712 0.000497189L10.106 0.000497189C11.5168 0.000497189 12.6433 0.000497233 13.5376 0.10338C14.4582 0.210107 15.2308 0.434152 15.8844 0.951431C16.1407 1.15527 16.3737 1.38699 16.5787 1.6418C17.0989 2.29178 17.3242 3.06003 17.4316 3.9754C17.5224 4.76096 17.5331 5.72632 17.5341 6.908L17.535 6.92339V7.43683C17.535 7.86087 17.1879 8.20604 16.7615 8.20604C16.3341 8.20604 15.9879 7.86087 15.9879 7.43683V7.37433C15.9879 5.94456 15.985 4.93208 15.8941 4.15226C15.8042 3.37825 15.6359 2.93402 15.369 2.60133C15.2366 2.43595 15.0857 2.28597 14.9194 2.15423C14.5848 1.88886 14.1381 1.72155 13.3597 1.63213C12.5649 1.54078 11.5283 1.53886 10.0565 1.53886L7.99404 1.53886C6.26998 1.53886 5.0555 1.54078 4.13589 1.66385C3.23856 1.78404 2.73961 2.00615 2.37796 2.36481C2.01729 2.7244 1.79391 3.22056 1.67304 4.11285C1.54927 5.02724 1.54734 6.23491 1.54734 7.9493L1.54734 12.0521C1.54734 13.7655 1.54927 14.9741 1.67304 15.8885C1.79391 16.7799 2.01727 17.277 2.37796 17.6356C2.73959 17.9943 3.23856 18.2173 4.13589 18.3375C5.05545 18.4606 6.26995 18.4616 7.99404 18.4616C8.42144 18.4616 8.7676 18.8068 8.7676 19.2308C8.7676 19.6558 8.42144 20 7.99404 20H7.93699C6.2835 20 4.96453 20 3.92982 19.8625C2.86134 19.7192 1.98044 19.4164 1.28411 18.7241C0.587907 18.0308 0.283309 17.1558 0.139241 16.0932C0 15.0644 0 13.7529 0 12.1086L0 7.89235C0 6.24816 0 4.93661 0.139241 3.90772C0.283317 2.84524 0.587907 1.9693 1.28411 1.27689C1.98032 0.584477 2.86121 0.281716 3.92982 0.138458C4.96446 0 6.28338 0 7.93699 0L7.93712 0.000497189Z"
              fill="currentColor"
            />
            <path
              d="M4.38489 5.12891C3.95749 5.12891 3.61133 5.47312 3.61133 5.89812C3.61133 6.32216 3.95749 6.66733 4.38489 6.66733L12.6359 6.66733C13.0633 6.66733 13.4094 6.32216 13.4094 5.89812C13.4094 5.47312 13.0633 5.12891 12.6359 5.12891L4.38489 5.12891Z"
              fill="currentColor"
            />
            <path
              d="M3.61133 8.97624C3.61133 8.55124 3.95749 8.20703 4.38489 8.20703L9.54164 8.20703C9.96904 8.20703 10.3152 8.55124 10.3152 8.97624C10.3152 9.40028 9.96904 9.74545 9.54164 9.74545H4.38489C3.95749 9.74545 3.61133 9.40028 3.61133 8.97624Z"
              fill="currentColor"
            />
            <path
              d="M4.38489 11.2812C3.95749 11.2812 3.61133 11.6255 3.61133 12.0505C3.61133 12.4745 3.95749 12.8197 4.38489 12.8197H7.47914C7.90557 12.8197 8.2527 12.4745 8.2527 12.0505C8.2527 11.6255 7.90557 11.2812 7.47914 11.2812H4.38489Z"
              fill="currentColor"
            />
            <path
              d="M19.9993 19.6413V18.5747C19.9993 18.0089 19.7646 17.4663 19.3468 17.0662C18.929 16.6662 18.3623 16.4414 17.7715 16.4414H13.3157C12.7249 16.4414 12.1582 16.6662 11.7404 17.0662C11.3226 17.4663 11.0879 18.0089 11.0879 18.5747V19.6413"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.5443 14.2275C16.7747 14.2275 17.7721 13.2357 17.7721 12.0122C17.7721 10.7887 16.7747 9.79688 15.5443 9.79688C14.3139 9.79688 13.3164 10.7887 13.3164 12.0122C13.3164 13.2357 14.3139 14.2275 15.5443 14.2275Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

        ),
        submenu: [
          { id: 'clients', label: t('SIDEBAR_ALL_CLIENTS'), href: '/v2/my-clients' },
          { id: 'freelancers', label: t('SIDEBAR_ALL_FREELANCERS'), href: '/v2/my-freelancers' },
          { id: 'contracts', label: t('CONTRACTS_AND_AGREEMENTS'), href: '/v2/my-contracts' },
           { id: 'employer-cert', label: t('EMPLOYER_CERTIFICATE'), href: '/v2/employer-certificate' },
          // { id: 'freelancer-certificate', label: t('FREELANCER_AND_CERTIFICATE'), href: '/v2/freelancer-certificate' }

        ]
      },
      {
        id: 'time-earnings',
        label: t('SIDEBAR_TIME_EARNINGS'),
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M13.333 3.33464C13.333 4.25511 11.0944 5.0013 8.33301 5.0013C5.57158 5.0013 3.33301 4.25511 3.33301 3.33464M13.333 3.33464C13.333 2.41416 11.0944 1.66797 8.33301 1.66797C5.57158 1.66797 3.33301 2.41416 3.33301 3.33464M13.333 3.33464V6.66797M3.33301 3.33464L3.33301 6.66797C3.33301 7.58844 5.57158 8.33464 8.33301 8.33464C11.0944 8.33464 13.333 7.58844 13.333 6.66797M16.6663 8.2398C16.6663 9.16027 14.4278 9.90647 11.6663 9.90647C8.90492 9.90647 6.66634 9.16027 6.66634 8.2398L6.66634 11.5732M16.6663 8.2398C16.6663 7.51412 15.275 6.89677 13.333 6.66797M16.6663 8.2398V11.5732C16.6663 12.4936 14.4278 13.2398 11.6663 13.2398C8.90492 13.2398 6.66634 12.4936 6.66634 11.5732M3.33301 13.145C3.33301 14.0655 5.57158 14.8117 8.33301 14.8117C11.0944 14.8117 13.333 14.0655 13.333 13.145V16.4784C13.333 17.3988 11.0944 18.145 8.33301 18.145C5.57158 18.145 3.33301 17.3988 3.33301 16.4784L3.33301 13.145ZM3.33301 13.145C3.33301 12.4193 4.72435 11.802 6.66634 11.5732"
              stroke="currentColor"
              strokeWidth={2}
            />
          </svg>

        ),
        submenu: [
          { id: 'timesheets-invoice', label: t('SIDEBAR_TIME_TRACKING'), href: '/v2/timesheets-invoice' },
          // { id: 'time-tracking', label: t('SIDEBAR_TIME_TRACKING'), href: '/v2/timesheets' },
          { id: 'deduction-invoice', label: t('SIDEBAR_DEDUCTION_INVOICE'), href: '/v2/deduction-invoice' },
          { id: 'statements-invoice', label: t('SIDEBAR_STATEMENTS_INVOICE'), href: '/v2/statements-invoice' },
          { id: 'salary-notice', label: t('SALARY_NOTICE'), href: 'salary-notice' }
        ]
      },
    ]
  },
  {
    id: 'insurance',
    title: t('SIDEBAR_INSURANCE'),
    items: [
      {
        id: 'health-and-insurance',
        label: t('SIDEBAR_INSURANCE'),
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M17.5003 8.67389C18.2202 10.0063 18.1021 11.6648 17.135 12.9208C16.0749 14.2977 12.8666 17.2016 11.8151 18.1414C11.6974 18.2466 11.6386 18.2992 11.57 18.3198C11.5101 18.3378 11.4446 18.3378 11.3847 18.3198C11.3161 18.2992 11.2573 18.2466 11.1397 18.1414C10.7874 17.8265 10.193 17.2912 9.51837 16.6667M8.14403 3.89719C6.84816 2.36812 4.6872 1.9568 3.06355 3.35698C1.43991 4.75715 1.21132 7.09818 2.48638 8.75417C3.5465 10.131 6.75481 13.0349 7.80632 13.9748C7.92396 14.0799 7.98278 14.1325 8.05139 14.1531C8.11127 14.1712 8.1768 14.1712 8.23668 14.1531C8.30529 14.1325 8.36411 14.0799 8.48175 13.9748C9.53326 13.0349 12.7416 10.131 13.8017 8.75417C15.0767 7.09818 14.8761 4.74242 13.2245 3.35698C11.573 1.97153 9.43991 2.36812 8.14403 3.89719Z"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
        href: '/v2/health-insurance',
        isActive: true
      },
      {
        id: 'pre-insurance',
        label: t('SIDEBAR_PRE_INSURANCE'),
        icon: (
         <svg
  width={20}
  height={20}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M17.015 7.68035L16.2148 8.28004L16.22 8.28706L16.2254 8.29398L17.015 7.68035ZM16.58 6.59192L17.5713 6.45985L17.5696 6.44809L16.58 6.59192ZM16.3625 5.09532L15.3718 5.23185L15.3729 5.23914L16.3625 5.09532ZM14.8127 3.5443L14.9773 2.55793L14.967 2.55622L14.9568 2.55473L14.8127 3.5443ZM13.3173 3.32661L13.4614 2.33704L13.4589 2.33668L13.3173 3.32661ZM12.2298 2.89124L11.6325 3.69324L11.6532 3.70871L11.6748 3.72308L12.2298 2.89124ZM11.0607 2.02049L10.4604 2.82026L10.4634 2.82249L11.0607 2.02049ZM8.88559 2.02049L8.28528 1.22072V1.22072L8.88559 2.02049ZM7.68929 2.91845L8.2896 3.71821V3.71821L7.68929 2.91845ZM6.60174 3.35382L6.46947 2.36261L6.46226 2.36357L6.45507 2.36464L6.60174 3.35382ZM5.13355 3.57151L5.2703 4.56217L5.28022 4.5607L5.13355 3.57151ZM3.58379 5.12253L2.59738 4.95826L2.59568 4.96847L2.59419 4.97871L3.58379 5.12253ZM3.36629 6.61913L2.37668 6.4753L2.37632 6.47782L3.36629 6.61913ZM2.93127 7.70756L3.7315 8.30725L3.74814 8.28505L3.76353 8.26195L2.93127 7.70756ZM2.03404 8.90484L2.83427 9.50453V9.50453L2.03404 8.90484ZM2.03404 11.0817L2.83427 10.482L2.82812 10.4738L2.82179 10.4657L2.03404 11.0817ZM2.93127 12.279L2.13103 12.8787H2.13103L2.93127 12.279ZM3.36629 13.3674L2.37497 13.4995L2.37668 13.5113L3.36629 13.3674ZM3.58379 14.864L4.57446 14.7275L4.5734 14.7202L3.58379 14.864ZM5.13355 16.415L4.96902 17.4014L4.97924 17.4031L4.9895 17.4046L5.13355 16.415ZM6.62893 16.6327L6.48487 17.6223L6.48739 17.6227L6.62893 16.6327ZM7.71648 17.0681L8.31679 16.2683L8.29458 16.2517L8.27149 16.2363L7.71648 17.0681ZM8.91278 17.9661L9.51309 17.1663H9.51309L8.91278 17.9661ZM11.0879 17.9661L10.4876 17.1663L10.4793 17.1725L10.4713 17.1788L11.0879 17.9661ZM12.2842 17.0681L12.8845 17.8679V17.8679L12.2842 17.0681ZM13.3717 16.6327L13.504 17.624L13.5158 17.6223L13.3717 16.6327ZM14.8671 16.415L14.7304 15.4244L14.723 15.4255L14.8671 16.415ZM16.4169 14.864L17.4033 15.0283L17.405 15.0181L17.4065 15.0079L16.4169 14.864ZM16.6344 13.3674L17.624 13.5113L17.6243 13.5087L16.6344 13.3674ZM17.0694 12.279L16.2691 11.6793L16.2525 11.7015L16.2371 11.7246L17.0694 12.279ZM17.9666 11.0817L18.7668 11.6814V11.6814L17.9666 11.0817ZM17.9666 8.90484L17.177 9.51848L17.1789 9.52084L17.9666 8.90484ZM9.99804 8.19868L9.24424 8.85577C9.43415 9.07364 9.70903 9.19868 9.99804 9.19868C10.2871 9.19868 10.5619 9.07364 10.7518 8.85577L9.99804 8.19868ZM7.08839 10.6272L7.87232 10.0063V10.0063L7.08839 10.6272ZM12.9077 10.6272L12.1238 10.0063V10.0063L12.9077 10.6272ZM9.82436 13.2375L9.16842 13.9923L9.82436 13.2375ZM9.9504 13.3267L9.66945 14.2864V14.2864L9.9504 13.3267ZM10.1717 13.2375L9.51579 12.4826L10.1717 13.2375ZM10.0457 13.3267L10.3266 14.2864L10.0457 13.3267ZM17.015 7.68035L17.8152 7.08067C17.6819 6.90277 17.605 6.71344 17.5712 6.45986L16.58 6.59192L15.5887 6.72398C15.6637 7.28672 15.8587 7.80488 16.2148 8.28004L17.015 7.68035ZM16.58 6.59192L17.5696 6.44809L17.3521 4.95149L16.3625 5.09532L15.3729 5.23914L15.5904 6.73574L16.58 6.59192ZM16.3625 5.09532L17.3531 4.95879C17.1815 3.71381 16.2019 2.7622 14.9773 2.55793L14.8127 3.5443L14.6482 4.53067C15.0549 4.5985 15.3259 4.8986 15.3718 5.23185L16.3625 5.09532ZM14.8127 3.5443L14.9568 2.55473L13.4614 2.33704L13.3173 3.32661L13.1733 4.31618L14.6687 4.53387L14.8127 3.5443ZM13.3173 3.32661L13.4589 2.33668C13.2544 2.30745 13.013 2.21163 12.7848 2.0594L12.2298 2.89124L11.6748 3.72308C12.0991 4.00622 12.619 4.23693 13.1758 4.31655L13.3173 3.32661ZM12.2298 2.89124L12.8271 2.08924L11.658 1.21849L11.0607 2.02049L10.4634 2.82249L11.6325 3.69324L12.2298 2.89124ZM11.0607 2.02049L11.661 1.22072C11.1433 0.832103 10.5462 0.666748 9.97314 0.666748V1.66675V2.66675C10.1614 2.66675 10.3256 2.71908 10.4604 2.82025L11.0607 2.02049ZM9.97314 1.66675V0.666748C9.40008 0.666748 8.80302 0.832102 8.28528 1.22072L8.88559 2.02049L9.4859 2.82025C9.62069 2.71908 9.78491 2.66675 9.97314 2.66675V1.66675ZM8.88559 2.02049L8.28528 1.22072L7.08897 2.11868L7.68929 2.91845L8.2896 3.71821L9.4859 2.82025L8.88559 2.02049ZM7.68929 2.91845L7.08897 2.11868C6.91135 2.25201 6.72244 2.32885 6.46947 2.36261L6.60174 3.35382L6.73401 4.34504C7.2967 4.26995 7.8147 4.07468 8.2896 3.71821L7.68929 2.91845ZM6.60174 3.35382L6.45507 2.36464L4.98688 2.58232L5.13355 3.57151L5.28022 4.5607L6.7484 4.34301L6.60174 3.35382ZM5.13355 3.57151L4.9968 2.5809C3.75154 2.7528 2.80128 3.73386 2.59738 4.95826L3.58379 5.12253L4.57021 5.2868C4.6382 4.87855 4.93862 4.6079 5.2703 4.56212L5.13355 3.57151ZM3.58379 5.12253L2.59419 4.97871L2.37668 6.4753L3.36629 6.61913L4.35589 6.76295L4.5734 5.26636L3.58379 5.12253ZM3.36629 6.61913L2.37632 6.47782C2.34705 6.68285 2.25117 6.92474 2.09901 7.15318L2.93127 7.70756L3.76353 8.26195C4.04638 7.83732 4.27676 7.31731 4.35625 6.76044L3.36629 6.61913ZM2.93127 7.70756L2.13103 7.10788L1.2338 8.30516L2.03404 8.90484L2.83427 9.50453L3.7315 8.30725L2.93127 7.70756ZM2.03404 8.90484L1.2338 8.30516C0.483896 9.30585 0.468051 10.7025 1.24629 11.6977L2.03404 11.0817L2.82179 10.4657C2.62124 10.2092 2.60539 9.80996 2.83427 9.50453L2.03404 8.90484ZM2.03404 11.0817L1.2338 11.6814L2.13103 12.8787L2.93127 12.279L3.7315 11.6793L2.83427 10.482L2.03404 11.0817ZM2.93127 12.279L2.13103 12.8787C2.26435 13.0566 2.34126 13.2459 2.37504 13.4995L3.36629 13.3674L4.35753 13.2354C4.28256 12.6726 4.08758 12.1545 3.7315 11.6793L2.93127 12.279ZM3.36629 13.3674L2.37668 13.5113L2.59419 15.0079L3.58379 14.864L4.5734 14.7202L4.35589 13.2236L3.36629 13.3674ZM3.58379 14.864L2.59316 15.0006C2.76474 16.2455 3.74437 17.1971 4.96902 17.4014L5.13355 16.415L5.29808 15.4287C4.89141 15.3608 4.62036 15.0607 4.57443 14.7275L3.58379 14.864ZM5.13355 16.415L4.9895 17.4046L6.48487 17.6223L6.62893 16.6327L6.77298 15.6432L5.27761 15.4255L5.13355 16.415ZM6.62893 16.6327L6.48739 17.6227C6.69184 17.6519 6.93329 17.7477 7.16146 17.9L7.71648 17.0681L8.27149 16.2363C7.84713 15.9531 7.3273 15.7224 6.77046 15.6428L6.62893 16.6327ZM7.71648 17.0681L7.11616 17.8679L8.31247 18.7658L8.91278 17.9661L9.51309 17.1663L8.31679 16.2683L7.71648 17.0681ZM8.91278 17.9661L8.31246 18.7658C9.31288 19.5168 10.7095 19.5326 11.7045 18.7533L11.0879 17.9661L10.4713 17.1788C10.2155 17.3791 9.81774 17.395 9.51309 17.1663L8.91278 17.9661ZM11.0879 17.9661L11.6882 18.7658L12.8845 17.8679L12.2842 17.0681L11.6839 16.2683L10.4876 17.1663L11.0879 17.9661ZM12.2842 17.0681L12.8845 17.8679C13.0621 17.7345 13.251 17.6577 13.504 17.6239L13.3717 16.6327L13.2395 15.6415C12.6768 15.7166 12.1588 15.9119 11.6839 16.2683L12.2842 17.0681ZM13.3717 16.6327L13.5158 17.6223L15.0112 17.4046L14.8671 16.415L14.723 15.4255L13.2277 15.6432L13.3717 16.6327ZM14.8671 16.415L15.0038 17.4057C16.2491 17.2338 17.1994 16.2527 17.4033 15.0283L16.4169 14.864L15.4304 14.6998C15.3625 15.108 15.062 15.3787 14.7304 15.4244L14.8671 16.415ZM16.4169 14.864L17.4065 15.0079L17.624 13.5113L16.6344 13.3674L15.6448 13.2236L15.4273 14.7202L16.4169 14.864ZM16.6344 13.3674L17.6243 13.5087C17.6536 13.3037 17.7495 13.0618 17.9016 12.8334L17.0694 12.279L16.2371 11.7246C15.9543 12.1492 15.7239 12.6692 15.6444 13.2261L16.6344 13.3674ZM17.0694 12.279L17.8696 12.8787L18.7668 11.6814L17.9666 11.0817L17.1664 10.482L16.2691 11.6793L17.0694 12.279ZM17.9666 11.0817L18.7668 11.6814C19.5168 10.6807 19.5326 9.28408 18.7544 8.28885L17.9666 8.90484L17.1789 9.52084C17.3794 9.77731 17.3953 10.1766 17.1664 10.482L17.9666 11.0817ZM17.9666 8.90484L18.7562 8.29121L17.8046 7.06672L17.015 7.68035L16.2254 8.29398L17.177 9.51847L17.9666 8.90484ZM9.99804 8.19868L10.7518 7.54158C9.78905 6.43707 8.0636 6.05485 6.74275 7.16227L7.38522 7.92857L8.0277 8.69487C8.37688 8.40212 8.87414 8.43121 9.24424 8.85577L9.99804 8.19868ZM7.38522 7.92857L6.74275 7.16227C5.50009 8.20413 5.30674 9.9882 6.30446 11.248L7.08839 10.6272L7.87232 10.0063C7.55856 9.61013 7.60033 9.05319 8.0277 8.69487L7.38522 7.92857ZM12.9077 10.6272L13.6916 11.248C14.6803 9.99965 14.524 8.19844 13.2429 7.15362L12.6109 7.92857L11.9788 8.70352C12.3965 9.04414 12.4466 9.59869 12.1238 10.0063L12.9077 10.6272ZM12.6109 7.92857L13.2429 7.15362C11.9181 6.07313 10.2145 6.42854 9.24424 7.54158L9.99804 8.19868L10.7518 8.85577C11.1145 8.43974 11.6049 8.39856 11.9788 8.70352L12.6109 7.92857ZM7.08839 10.6272L6.30446 11.248C6.63255 11.6623 7.23861 12.2478 7.77852 12.7479C8.33789 13.266 8.89452 13.7543 9.16842 13.9923L9.82436 13.2375L10.4803 12.4826C10.2134 12.2507 9.67467 11.7781 9.13755 11.2806C8.58098 10.7651 8.08944 10.2805 7.87232 10.0063L7.08839 10.6272ZM10.1717 13.2375L10.8277 13.9923C11.1016 13.7543 11.6582 13.266 12.2176 12.7479C12.7575 12.2478 13.3635 11.6623 13.6916 11.248L12.9077 10.6272L12.1238 10.0063C11.9066 10.2805 11.4151 10.7651 10.8585 11.2806C10.3214 11.7781 9.78266 12.2507 9.51579 12.4826L10.1717 13.2375ZM9.82436 13.2375L9.16842 13.9923C9.18688 14.0083 9.24384 14.0588 9.30256 14.1022C9.37332 14.1544 9.49692 14.2359 9.66945 14.2864L9.9504 13.3267L10.2313 12.3669C10.3686 12.4071 10.4594 12.4702 10.4911 12.4936C10.5058 12.5045 10.5135 12.5112 10.5088 12.5073C10.504 12.5032 10.4971 12.4972 10.4803 12.4826L9.82436 13.2375ZM10.1717 13.2375L9.51579 12.4826C9.49898 12.4972 9.49204 12.5032 9.48725 12.5073C9.48256 12.5112 9.49028 12.5045 9.50498 12.4936C9.53666 12.4702 9.6275 12.4071 9.76474 12.3669L10.0457 13.3267L10.3266 14.2864C10.4992 14.2359 10.6228 14.1544 10.6935 14.1022C10.7522 14.0588 10.8092 14.0083 10.8277 13.9923L10.1717 13.2375ZM9.9504 13.3267L9.66945 14.2864C9.8837 14.3491 10.1124 14.3491 10.3266 14.2864L10.0457 13.3267L9.76474 12.3669C9.91739 12.3222 10.0787 12.3222 10.2313 12.3669L9.9504 13.3267Z"
    fill="currentColor"
  />
</svg>

        ),
        href: routes?.preInsurance || '/v2/pre-insurance',
        isNew: true,
        isActive: true
      },
    ]
  },
  {
    id: 'growth',
    title: t('SIDEBAR_GROWTH'),
    items: [
      {
        id: 'tools',
        label: t('SIDEBAR_TOOLS'),
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M6.66634 4.9987V8.33203M14.8567 12.4987L12.4997 14.8557M8.33301 12.4987L6.12764 14.7041C5.96492 14.8668 5.7011 14.8668 5.53838 14.7041L4.99967 14.1654M8.33301 6.66536H4.99967M14.8567 14.8559L12.4997 12.4989M14.9997 6.66536L11.6663 6.66536M7.49967 19.1654L12.4997 19.1654C14.8332 19.1654 16 19.1654 16.8913 18.7112C17.6753 18.3118 18.3127 17.6743 18.7122 16.8903C19.1663 15.999 19.1663 14.8322 19.1663 12.4987L19.1663 7.4987C19.1663 5.16515 19.1663 3.99837 18.7122 3.10707C18.3127 2.32306 17.6753 1.68564 16.8913 1.28617C16 0.832031 14.8332 0.832031 12.4997 0.832031L7.49967 0.832031C5.16612 0.832031 3.99935 0.832031 3.10805 1.28617C2.32404 1.68564 1.68662 2.32306 1.28715 3.10707C0.833008 3.99837 0.833008 5.16515 0.833008 7.4987L0.833008 12.4987C0.833008 14.8322 0.833008 15.999 1.28715 16.8903C1.68662 17.6743 2.32404 18.3118 3.10805 18.7112C3.99935 19.1654 5.16612 19.1654 7.49967 19.1654Z"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
            />
          </svg>

        ),
        submenu: [
          { id: 'calculator', label: t('SIDEBAR_CALCULATOR'), href: '/v2/salary-calculator' },
        ]
      },
      {
        id: 'resources',
        label: t('SIDEBAR_RESOURCES'),
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={22}
            height={22}
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              d="M4.10805 19.7112L4.56204 18.8202H4.56204L4.10805 19.7112ZM2.28715 17.8903L3.17815 17.4363H3.17815L2.28715 17.8903ZM17.8913 2.28617L17.4373 3.17718V3.17718L17.8913 2.28617ZM19.7122 4.10707L18.8212 4.56106V4.56106L19.7122 4.10707ZM4.10805 2.28617L4.56204 3.17718H4.56204L4.10805 2.28617ZM2.28715 4.10707L3.17815 4.56106V4.56106L2.28715 4.10707ZM19.1663 10.9987C19.1663 11.551 19.6141 11.9987 20.1663 11.9987C20.7186 11.9987 21.1663 11.551 21.1663 10.9987H20.1663H19.1663ZM10.9997 21.1654C11.552 21.1654 11.9997 20.7176 11.9997 20.1654C11.9997 19.6131 11.552 19.1654 10.9997 19.1654V20.1654V21.1654ZM14.333 14.1654C13.7807 14.1654 13.333 14.6131 13.333 15.1654C13.333 15.7176 13.7807 16.1654 14.333 16.1654V15.1654V14.1654ZM16.0848 16.013L15.2639 15.442L16.0848 16.013ZM18.5608 18.9459C18.8078 18.4519 18.6075 17.8513 18.1136 17.6043C17.6196 17.3573 17.0189 17.5575 16.7719 18.0515L17.6663 18.4987L18.5608 18.9459ZM15.687 10.5195C15.1347 10.5195 14.687 10.9672 14.687 11.5195C14.687 12.0718 15.1347 12.5195 15.687 12.5195V11.5195V10.5195ZM16.312 12.5195C16.8643 12.5195 17.312 12.0718 17.312 11.5195C17.312 10.9672 16.8643 10.5195 16.312 10.5195V11.5195V12.5195ZM15.687 11.1445C15.1347 11.1445 14.687 11.5922 14.687 12.1445C14.687 12.6968 15.1347 13.1445 15.687 13.1445V12.1445V11.1445ZM16.312 13.1445C16.8643 13.1445 17.312 12.6968 17.312 12.1445C17.312 11.5922 16.8643 11.1445 16.312 11.1445V12.1445V13.1445ZM1.83301 6.66536C1.28072 6.66536 0.833008 7.11308 0.833008 7.66536C0.833008 8.21765 1.28072 8.66536 1.83301 8.66536L1.83301 7.66536V6.66536ZM20.1663 8.66536C20.7186 8.66536 21.1663 8.21765 21.1663 7.66536C21.1663 7.11308 20.7186 6.66536 20.1663 6.66536V7.66536V8.66536ZM6.16634 5.16536C6.16634 4.61308 5.71863 4.16536 5.16634 4.16536C4.61406 4.16536 4.16634 4.61308 4.16634 5.16536H5.16634L6.16634 5.16536ZM8.66634 5.16536C8.66634 4.61308 8.21863 4.16536 7.66634 4.16536C7.11406 4.16536 6.66634 4.61308 6.66634 5.16536H7.66634H8.66634ZM11.1663 5.16536C11.1663 4.61308 10.7186 4.16536 10.1663 4.16536C9.61406 4.16536 9.16634 4.61308 9.16634 5.16536H10.1663H11.1663ZM4.16634 5.1737C4.16634 5.72598 4.61406 6.1737 5.16634 6.1737C5.71863 6.1737 6.16634 5.72598 6.16634 5.1737L5.16634 5.1737H4.16634ZM6.66634 5.1737C6.66634 5.72598 7.11406 6.1737 7.66634 6.1737C8.21863 6.1737 8.66634 5.72598 8.66634 5.1737H7.66634H6.66634ZM9.16634 5.1737C9.16634 5.72598 9.61406 6.1737 10.1663 6.1737C10.7186 6.1737 11.1663 5.72598 11.1663 5.1737H10.1663H9.16634ZM8.49967 1.83203V2.83203L13.4997 2.83203V1.83203V0.832031L8.49967 0.832031V1.83203ZM1.83301 13.4987H2.83301L2.83301 8.4987H1.83301H0.833008L0.833008 13.4987H1.83301ZM8.49967 20.1654V19.1654C7.3164 19.1654 6.48908 19.1646 5.84445 19.1119C5.21149 19.0602 4.84322 18.9635 4.56204 18.8202L4.10805 19.7112L3.65406 20.6022C4.26417 20.9131 4.92494 21.0435 5.68158 21.1053C6.42655 21.1661 7.3494 21.1654 8.49967 21.1654V20.1654ZM1.83301 13.4987H0.833008C0.833008 14.649 0.83223 15.5718 0.893096 16.3168C0.954916 17.0734 1.08527 17.7342 1.39614 18.3443L2.28715 17.8903L3.17815 17.4363C3.03488 17.1552 2.93817 16.7869 2.88645 16.1539C2.83379 15.5093 2.83301 14.682 2.83301 13.4987H1.83301ZM4.10805 19.7112L4.56204 18.8202C3.96619 18.5166 3.48175 18.0322 3.17815 17.4363L2.28715 17.8903L1.39614 18.3443C1.89149 19.3165 2.68189 20.1069 3.65406 20.6022L4.10805 19.7112ZM13.4997 1.83203V2.83203C14.683 2.83203 15.5103 2.83281 16.1549 2.88548C16.7879 2.93719 17.1561 3.03391 17.4373 3.17718L17.8913 2.28617L18.3453 1.39516C17.7352 1.08429 17.0744 0.95394 16.3178 0.89212C15.5728 0.831254 14.6499 0.832031 13.4997 0.832031V1.83203ZM20.1663 8.4987H21.1663C21.1663 7.34842 21.1671 6.42557 21.1063 5.68061C21.0444 4.92397 20.9141 4.2632 20.6032 3.65308L19.7122 4.10707L18.8212 4.56106C18.9645 4.84224 19.0612 5.21051 19.1129 5.84347C19.1656 6.4881 19.1663 7.31542 19.1663 8.4987H20.1663ZM17.8913 2.28617L17.4373 3.17718C18.0332 3.48078 18.5176 3.96521 18.8212 4.56106L19.7122 4.10707L20.6032 3.65308C20.1079 2.68091 19.3175 1.89051 18.3453 1.39516L17.8913 2.28617ZM8.49967 1.83203V0.832031C7.3494 0.832031 6.42655 0.831254 5.68158 0.89212C4.92494 0.95394 4.26417 1.08429 3.65406 1.39516L4.10805 2.28617L4.56204 3.17718C4.84322 3.03391 5.21149 2.93719 5.84445 2.88548C6.48908 2.83281 7.3164 2.83203 8.49967 2.83203V1.83203ZM1.83301 8.4987H2.83301C2.83301 7.31542 2.83379 6.4881 2.88645 5.84347C2.93817 5.21051 3.03488 4.84224 3.17815 4.56106L2.28715 4.10707L1.39614 3.65308C1.08527 4.2632 0.954916 4.92397 0.893096 5.68061C0.83223 6.42557 0.833008 7.34842 0.833008 8.4987H1.83301ZM4.10805 2.28617L3.65406 1.39516C2.68189 1.89051 1.89149 2.68091 1.39614 3.65308L2.28715 4.10707L3.17815 4.56106C3.48175 3.96521 3.96619 3.48078 4.56204 3.17718L4.10805 2.28617ZM20.1663 8.4987H19.1663V10.9987H20.1663H21.1663V8.4987H20.1663ZM10.9997 20.1654V19.1654H8.49967V20.1654V21.1654H10.9997V20.1654ZM14.333 15.1654V16.1654H15.6993V15.1654V14.1654H14.333V15.1654ZM16.0848 16.013L15.2639 15.442C14.6805 16.2807 14.1663 17.4341 14.1663 18.4987H15.1663H16.1663C16.1663 17.9976 16.4477 17.2426 16.9058 16.5841L16.0848 16.013ZM15.1663 18.4987H14.1663C14.1663 19.6291 14.964 20.4834 16.0043 20.5875C17.0415 20.6912 18.0098 20.0477 18.5608 18.9459L17.6663 18.4987L16.7719 18.0515C16.4895 18.6163 16.2078 18.5979 16.2033 18.5974C16.1917 18.5962 16.1861 18.5937 16.1848 18.593C16.1841 18.5926 16.1839 18.5925 16.184 18.5926C16.1842 18.5927 16.1844 18.5929 16.1843 18.5929C16.1843 18.5928 16.1842 18.5927 16.1839 18.5923C16.1837 18.592 16.1833 18.5914 16.1827 18.5905C16.1817 18.5888 16.1798 18.5853 16.1776 18.5794C16.1735 18.5684 16.1663 18.543 16.1663 18.4987H15.1663ZM15.6993 15.1654V16.1654C15.3868 16.1654 15.2395 15.9509 15.2049 15.8719C15.172 15.797 15.1349 15.6275 15.2639 15.442L16.0848 16.013L16.9058 16.5841C17.2562 16.0803 17.2202 15.487 17.0361 15.0678C16.8502 14.6445 16.3995 14.1654 15.6993 14.1654V15.1654ZM16.833 11.832H15.833C15.833 11.74 15.9076 11.6654 15.9997 11.6654V12.6654V13.6654C17.0122 13.6654 17.833 12.8446 17.833 11.832H16.833ZM15.9997 12.6654V11.6654C16.0917 11.6654 16.1663 11.74 16.1663 11.832H15.1663H14.1663C14.1663 12.8446 14.9872 13.6654 15.9997 13.6654V12.6654ZM15.1663 11.832H16.1663C16.1663 11.9241 16.0917 11.9987 15.9997 11.9987V10.9987V9.9987C14.9872 9.9987 14.1663 10.8195 14.1663 11.832H15.1663ZM15.9997 10.9987V11.9987C15.9076 11.9987 15.833 11.9241 15.833 11.832H16.833H17.833C17.833 10.8195 17.0122 9.9987 15.9997 9.9987V10.9987ZM15.687 11.5195V12.5195H16.312V11.5195V10.5195H15.687V11.5195ZM15.687 12.1445V13.1445H16.312V12.1445V11.1445H15.687V12.1445ZM1.83301 7.66536L1.83301 8.66536L20.1663 8.66536V7.66536V6.66536L1.83301 6.66536V7.66536ZM5.16634 5.16536H4.16634V5.1737H5.16634L6.16634 5.1737V5.16536L5.16634 5.16536ZM7.66634 5.16536H6.66634V5.1737H7.66634H8.66634V5.16536H7.66634ZM10.1663 5.16536H9.16634V5.1737H10.1663H11.1663V5.16536H10.1663Z"
              fill="currentColor"
            />
          </svg>
        ),
        isExpanded: true,
        submenu: [
          { id: 'loyalty-program', label: t('SIDEBAR_LOYALTY_PROGRAM'), href: '/loyalty-program', isActive: true },
          { id: 'faq-help', label: t('SIDEBAR_FAQ_HELP'), href: '/v2/faq' },
          // { id: 'terms', label: t('SIDEBAR_TERMS'), href: 'terms-and-condition' },
        ]
      }
    ]
  }
];


interface SidebarProps {
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
  activeItemId?: string;
  onMenuItemSelect?: (id: string, item: any) => void;
  onClose?: () => void;
  logo?: string | React.ReactNode;
  menuSections?: any[];
  className?: string;
  footer?: React.ReactNode;
  lang?: 'en-us' | 'sv-se';
}

export const Sidebar = ({
  
  isCollapsed = false,
  activeItemId = 'dashboard',
  onMenuItemSelect,
  onClose,
  logo = invozioLogo,
  menuSections,
  className = '',
}: SidebarProps) => {
  const location = useLocation();
  const { t } = useTranslation();
  const { routes } = useLocalizedRoutes();
  const { isV2Mode, isLoading, toggleVersion } = useVersionSwitcher();
  const navigate = useNavigate();
  const getInitialExpandedItems = () => {
    const sections = menuSections || defaultMenuSections(t, routes);
    const expandedSet = new Set<string | number>(['resources'])
    sections.forEach(section => {
      section.items.forEach((item: any) => {
        if (item.submenu) {
          const hasActiveChild = item.submenu.some((subItem: any) => subItem.id === activeItemId);
          if (hasActiveChild) {
            expandedSet.add(item.id);
          }
        }
      });
    });

    return expandedSet;
  };

  const [expandedItems, setExpandedItems] = useState(() => getInitialExpandedItems());

  // Update expanded items when activeItemId changes
  useEffect(() => {
    const sections = menuSections || defaultMenuSections(t, routes);

    setExpandedItems(prev => {
      const newSet = new Set(prev);
      newSet.add('resources'); // Keep resources expanded by default

      sections.forEach(section => {
        section.items.forEach((item: any) => {
          if (item.submenu) {
            const hasActiveChild = item.submenu.some((subItem: any) => subItem.id === activeItemId);
            if (hasActiveChild) {
              newSet.add(item.id);
            }
          }
        });
      });

      return newSet;
    });
  }, [activeItemId, menuSections, t]);

  // Add Swedish route mapping for invoices
  const routeMap: Record<string, { en: string; sv: string }> = {
    'all-invoices': {
      en: '/v2/manage-invoice?lang=en-us',
      sv: '/v2/manage-invoice?lang=sv-se',
    },
    'draft-invoice': {
      en: '/v2/draft-invoice?lang=en-us',
      sv: '/v2/draft-invoice?lang=sv-se',
    },
    'salary-notice': {
      en: '/v2/salary-notice?lang=en-us',
      sv: '/v2/salary-notice?lang=sv-se',
    },
    'create-invoices': {
      en: '/v2/create-invoice?lang=en-us',
      sv: '/v2/create-invoice?lang=sv-se',
    },
    'all-contracts': {
      en: '/v2/my-contracts?lang=en-us',
      sv: '/v2/my-contracts?lang=sv-se',
    },
    'dashboard/economy/agreements': {
      en: '/dashboard/economy/agreements?lang=en-us',
      sv: '/instrumentbrada/ekonomi/avtal?lang=sv-se',
    },
    'time-tracking': {
      en: '/v2/timesheets?lang=en-us',
      sv: '/v2/timesheets?lang=sv-se',
    },
    'deduction-invoice': {
      en: '/v2/deduction-invoice?lang=en-us',
      sv: '/v2/deduction-invoice?lang=sv-se',
    },
    'timesheets-invoice': {
      en: '/v2/timesheets-invoice?lang=en-us',
      sv: '/v2/timesheets-invoice?lang=sv-se',
    },
    'statements-invoice': {
      en: '/v2/statements-invoice?lang=en-us',
      sv: '/v2/statements-invoice?lang=sv-se',
    },
    'health-and-insurance': {
      en: '/insurance?lang=en-us',
      sv: '/forsakring?lang=sv-se',
    },
    'insurance-claims': {
      en: '/insurance?lang=en-us',
      sv: '/forsakring?lang=sv-se',
    },
    'tool-calculator': {
      en: '/dashboard/calculator-anchor?lang=en-us',
      sv: '/instrumentbrada/kalkylator-ankare?lang=sv-se',
    },
    'tool-templates': {
      en: '/dashboard/calculator-anchor?lang=en-us',
      sv: '/instrumentbrada/kalkylator-ankare?lang=sv-se',
    },
    'ambassador': {
      en: '/ambassador?lang=en-us',
      sv: '/ambassador?lang=sv-se',
    },
    'faq': {
      en: '/faq?lang=en-us',
      sv: '/faq?lang=sv-se',
    },
    'safe-workplace': {
      en: '/start-your-own-business-or-invoice-as-a-private-person?lang=en-us',
      sv: '/starta-eget-foretag-eller-fakturera-som-privatperson?lang=sv-se',
    },
  };

  const handleMenuItemSelect = (item: Record<string, any>) => {
  onMenuItemSelect?.(item.id, item);

  let target = item.to || item.href;
  if (!target) {
    onClose?.();
    return;
  }

  const urlLang = (() => {
    const path = window.location.pathname;
    const searchParams = new URLSearchParams(window.location.search);
    const langParam = searchParams.get('lang');
    if (langParam === 'en-us') return 'en-us';
    if (langParam === 'sv-se') return 'sv-se';
    if (path.includes('/instrumentbrada/')) return 'sv-se';
    return 'en-us';
  })();

  if (routeMap[target]) {
    target = urlLang === 'sv-se'
      ? routeMap[target].sv
      : routeMap[target].en;
  } else {
    if (target.match(/[?&]lang=/)) {
      target = target.replace(/([?&]lang=)[^&]+/, `$1${urlLang}`);
    } else if (target.includes('?')) {
      target += `&lang=${urlLang}`;
    } else {
      target += `?lang=${urlLang}`;
    }
  }

  const currentUrl = location.pathname + location.search;

  if (currentUrl === target) {
    onClose?.();
    return;
  }

  navigate(target);
  window.scrollTo(0, 0);
  onClose?.();
};


  const handleToggleSubmenu = (itemId: string | number) => {
    const sections = menuSections || defaultMenuSections(t, routes);
    let hasActiveChild = false;

    // Check if this submenu has an active child
    sections.forEach(section => {
      section.items.forEach((item: any) => {
        if (item.id === itemId && item.submenu) {
          hasActiveChild = item.submenu.some((subItem: any) => subItem.id === activeItemId);
        }
      });
    });

    if (hasActiveChild) {
      return;
    }

    setExpandedItems(prev => {
      const newSet = new Set(prev);
      if (newSet.has(itemId)) {
        newSet.delete(itemId);
      } else {
        newSet.add(itemId);
      }
      return newSet;
    });
  };

  const isItemActive = (item: Record<string, any>) => {
    if (item.id === activeItemId) return true;
    if (item.submenu) {
      return item.submenu.some((subItem: Record<string, any>) => subItem.id === activeItemId);
    }
    return false;
  };

  const isSubmenuItemActive = (subItem: Record<string, any>) => {
    return subItem.id === activeItemId;
  };

  const sections = menuSections || defaultMenuSections(t, routes);
  // Always show sidebar, never collapsed
  return (
    <div className={`sidebar ${className}`} data-testid="sidebar">
      <div className="sidebar__content">
        <div className="sidebar__nav">
          <div className="sidebar__logo">
            {typeof logo === 'string' ? (
              <Link to={`/?lang=${i18n.language}`} reloadDocument>
                <img src={logo} alt="Invozio" className="sidebar__logo-image" />
              </Link>
            ) : (
              logo
            )}
            {/* Mobile close button */}
            {onClose && (
              <button
                className="sidebar__close-button"
                onClick={onClose}
                aria-label="Close menu"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            )}
          </div>
          {/* {isShownSwitcher && ( */}
            <div className="mobile-switcher d-md-none d-block">
              <div className="mobile-switcher__bg" />

              <div className="mobile-switcher__content">
                <div className="mobile-switcher__text">
                  <span className="mobile-switcher__title">
                    {t('MOBILE_VERSION_NOTIFICATION_TITLE')}
                  </span>
                  <br />
                  <span className="mobile-switcher__desc">
                    {t(
                      'MOBILE_VERSION_NOTIFICATION_DESC',
                    )}
                  </span>
                </div>

                <div className="version-toggle">
                  <span className={`version-label ${!isV2Mode ? 'active' : ''}`}>
                    V3
                  </span>

                  <button
                    onClick={toggleVersion}
                    disabled={isLoading}
                    aria-label={t('TOGGLE_VERSION')}
                    className={`toggle-btn ${isV2Mode ? 'v2' : ''}`}
                  >
                    <span className="toggle-thumb" />
                  </button>

                  <span className={`version-label ${isV2Mode ? 'active' : ''}`}>
                    V4
                  </span>
                </div>
              </div>
            </div>
          {/* )} */}

          {/* Menu Sections */}
          {sections.map(section => (
            <div key={section.id} className="sidebar__section">
              <div className="sidebar__section-title">{section.title}</div>
              <div className="sidebar__section-items">
                {section.items.map((item: any) => (
                  <MenuItem
                    key={item.id}
                    item={{
                      ...item,
                      isExpanded: expandedItems.has(item.id),
                      submenu: item.submenu?.map((subItem: any) => ({
                        ...subItem,
                        isActive: isSubmenuItemActive(subItem)
                      }))
                    }}
                    isActive={isItemActive(item)}
                    onSelect={handleMenuItemSelect}
                    onToggleSubmenu={handleToggleSubmenu}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
